import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#29474d",
    },
    secondary: {
      main: "#FFC107",
    },
    background: {
      default: "#FFF8E1",
    },
  },
  typography: {
    fontFamily: "Open Sans, sans-serif",
    h1: {
      fontSize: "2rem",
    },
    button: {
      textTransform: "none",
    },
  },
});

export default theme;
